import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      data: null
    }
  },
  getters: {
    user(state){
      return state.user
    }
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    }
  },
  actions: {
    async fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        const tokenResult = await user.getIdTokenResult();
        commit("SET_USER", {
          displayName: user.displayName,
          email: user.email,
          claims: {
            user: tokenResult.claims.user ? true : false,
            admin: tokenResult.claims.admin ? true : false,
            betrachter: tokenResult.claims.betrachter ? true : false,
            betrachter_ohne_antwort_funktion: tokenResult.claims.betrachter_ohne_antwort_funktion ? true : false
          },
          uid: user.uid
        });
      } else {
        commit("SET_USER", null);
      }
    }
  }
});